// extracted by mini-css-extract-plugin
module.exports = {"leftMenu":"leftMenu_leftMenu__2yITC","leftMenu__button":"leftMenu_leftMenu__button__DMIne","leftMenu__textWrite":"leftMenu_leftMenu__textWrite__bbWp3"};